import './Popup.scss';

export default function UpDatePopup({ onClick, }) {
    return (
        <div className='popup_container' >
            <div className='white_block' >
                <h3>Settings has been updated</h3>

                <button
                    onClick={onClick}
                >
                    Ok
                </button>


            </div>
        </div>
    )
}